<template>
  <div>
    <v-row v-if="loading" justify="center">
      <RingLoader :color="'rgba(238, 117, 4, 0.993)'" />
    </v-row>

    <v-container v-else>
      <v-row justify="center">
        <v-col class="card-col">
          <div class="row card-row-bg card-row wrap">
            <div
              v-for="(card, index) in categories"
              :key="index"
              :ref="`card_${index}`"
              @mouseover="hoverCard(index)"
              @mouseout="hoverCard(-1)"
              @click="category(card)"
              class="card"
            >
              <div>
                <img
                  class="card-image"
                  :class="{ selected: isSelected(index) }"
                  @load="onLoaded"
                  @error="onImageLoadFailure($event)"
                  v-show="loaded"
                  :src="urlImage + selectedCategory + '/' + card.name + '.png'"
                />

                <img
                  class="card-image"
                  v-show="loaded == false"
                  src="@/assets/loader.gif"
                />
              </div>

              <div class="card-footer">
                <h3 class="card-text">{{ card.name }}</h3>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { RingLoader } from "vue-spinners-css";

export default {
  name: "categoriesT2",

  components: { RingLoader },

  data() {
    return {
      categories: [],
      selectedCard: -1,
      loading: false,
      loaded: false,
      selectedCategory: "",
      urlImage:
        "https://risoulimages.s3.us-west-2.amazonaws.com/IMAGENES+NIVELES/NoPDI/",
    };
  },

  props: {},

  methods: {
    getParentCategory: function () {
      this.selectedCategory = this.$route.params.categoryT2;
      this.loading = true;
      var parentId = this.$route.query.idCategory;

      this.$http
        .get(`category/search?pdi=false&parentId=` + parentId)
        .then(
          (response) => {
            var list = response.body.data;
            this.categories = list;
            this.loading = false;
          },
          (error) => {
            this.snackbar(
              error.message ||
                "Hubo un problema al obtener la lista de categorias"
            );
            console.error(error);
          }
        )
        .finally(() => (this.loading = false));
    },

    category: function (item) {
      var tier2 = this.$route.params.categoryT2;
      this.$router.push(
        `/category/${encodeURIComponent(tier2)}/${encodeURIComponent(
          item.name
        )}?idCategory=${item.id}`
      );
      this.$router.go();
    },

    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex;
    },

    isSelected(cardIndex) {
      return this.selectedCard === cardIndex;
    },

    onLoaded() {
      this.loaded = true;
    },

    onImageLoadFailure(event) {
      event.target.src =
        "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/GENERICA RISOUL.png";
    },
  },

  watch: {
    "$route.query": function () {
      this.$router.go();
    },
  },

  created() {
    this.getParentCategory();
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
